import { faCircleCheck, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons"
import Box from "@mui/material/Box"
import { CustomContentProps, SnackbarContent, SnackbarProvider } from "notistack"
import React from "react"

/**
 * Example:
 * enqueueSnackbar("Filters reset successfully", { variant: "success", autoHideDuration: 3000 })
 * enqueueSnackbar("Filters reset successfully", { variant: "error" })
 * enqueueSnackbar("Filters reset successfully")
 */

const BACKGROUND_COLOR = "#252525"
const TEXT_COLOR = "#FFFFFF"

const DEFAULT_DURATION = 2000

const SnackbarSuccessIcon = () => <FontAwesomeIcon icon={faCircleCheck} color="#1EA672" />
const SnackbarErrorIcon = () => <FontAwesomeIcon icon={faTriangleExclamation} color="#F94054" />
const SnacbarInfoIcon = () => <FontAwesomeIcon icon={faCircleInfo} color="#869debff" />

interface CustomSnackbarContentProps extends CustomContentProps {
    icon: React.ReactNode
    message: string
}

const CustomSnackbarContent = React.forwardRef<HTMLDivElement, CustomSnackbarContentProps>((props, ref) => {
    const { id, message, variant, ...other } = props

    const getIcon = () => {
        if (variant === "success") return <SnackbarSuccessIcon />
        if (variant === "error") return <SnackbarErrorIcon />
        if (variant === "info") return <SnacbarInfoIcon />
        return null
    }
    return (
        <SnackbarContent ref={ref} role="alert" {...other}>
            <Box
                bgcolor={BACKGROUND_COLOR}
                color={TEXT_COLOR}
                display="flex"
                padding="12px 16px"
                alignItems="center"
                borderRadius="4px"
                width="100%"
                fontSize="14px"
                gap="8px">
                {getIcon()}
                {message}
            </Box>
        </SnackbarContent>
    )
})

const CustomSnackbar = () => (
    <SnackbarProvider
        anchorOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        autoHideDuration={DEFAULT_DURATION}
        Components={{
            success: CustomSnackbarContent,
            error: CustomSnackbarContent,
            default: CustomSnackbarContent,
            warning: CustomSnackbarContent,
            info: CustomSnackbarContent,
        }}
    />
)

export default CustomSnackbar
